import Phaser from 'phaser';
import { audioManager } from '@/systems/AudioManager';
import { addBackdrop } from '@/ui/background';
import { Palette, Typography } from '@/ui/theme';
import { fadeInScene, fadeToScene } from '@/utils/transitions';

/**
 * BootScene — primeira cena. A partir do PR 4 não inicializa SaveSystem
 * aqui: a vinculação do save acontece quando há aluno ativo (em
 * PreloadScene ou ProfileSelectScene). BootScene só prepara áudio + splash.
 */
export class BootScene extends Phaser.Scene {
  constructor() {
    super({ key: 'BootScene' });
  }

  async create(): Promise<void> {
    addBackdrop(this);
    fadeInScene(this);
    const { width, height } = this.scale;
    this.add
      .text(width / 2, height / 2, 'Tabuada Geek', {
        fontFamily: Typography.fontFamily,
        fontSize: '48px',
        color: Palette.textPrimaryCss,
        fontStyle: 'bold',
      })
      .setOrigin(0.5);

    audioManager.init();

    // Destrava o AudioContext no primeiro pointerdown — política de
    // autoplay do navegador exige um gesto antes de iniciar áudio.
    this.input.once(Phaser.Input.Events.POINTER_DOWN, () => audioManager.unlock());

    fadeToScene(this, 'PreloadScene');
  }
}
